import Vue from 'vue';
import HttpMixin from '@/mixins/HttpMixin';
import flatPickr from 'vue-flatpickr-component';
import VueSimpleSpinner from "vue-simple-spinner";
import {UserRoleEnum} from '@/enums/userRolesEnum';
import { BallPulseLoader } from 'vue-loaders';

export default Vue.extend({
  name: 'BillablePayablesReport',
  mixins: [ HttpMixin ],
  components: {
    VueSimpleSpinner,
    flatPickr,
    BallPulseLoader
  },
  data() {
    return {
      isAuthorized: true,
      searchParametersCardExpanded: false,
      loadingSearchResults: false,
      transactionTypes: [] as any[],
      startDate: '',
      endDate: '',
      useReceiptDates: false,
      useInvoicePeriods: true,
      type: -1,
      typeFilters: {
        filters: [],
        isAnd: false
      },
      results: {
        totalInvoices: 0,
        totalProviders: 0,
        totalFacilities: 0,
        totalBillable: 0,
        totalPayable: 0,
        totalMargin: 0,
        totalRows: 0,
        totalQuantity: 0,
      },
      tableResults: [],
      resultsExpanded: false,
      ourConfig: null
    };
  },
  watch: {
    type(newVal) {
      const id = Number(newVal);
      const found = this.transactionTypes.filter((type: any) => type.id === id).pop();
      if (found) {
        this.type = -1;
        this.addFilter(this.typeFilters.filters, found);
      }
    },
    useReceiptDates(newVal: boolean) {
      this.useInvoicePeriods = !newVal;
      this.setConfig();
    },
    useInvoicePeriods(newVal: boolean) {
      this.useReceiptDates = !newVal;
      this.setConfig();
    },
  },
  beforeMount: function () {
    this.isAuthorized = this.$store.getters['user/hasRole']([
      UserRoleEnum.MANAGER,
      UserRoleEnum.ACCOUNTANT
    ]);
  },
  async created() {
    this.setConfig();
    await this.expandCard();
  },
  methods: {
    setConfig() {
      const toDisable = this.useInvoicePeriods ? [ (date: Date) => date.getDay() !== 0 && date.getDay() !== 1] : [];
      this.ourConfig = Object.assign({}, (this as any).nmrFlatpickrConfig, { disable: toDisable });
      this.resetDates();
    },
    resetDates() {
      // Start the week on a Monday, not a Sunday
      const now = new Date();
      const dayMinus = now.getDay() === 0 ? 6 : now.getDay() - 1;

      const weekStartDay = new Date(now.getTime());
      weekStartDay.setDate(weekStartDay.getDate() - dayMinus);

      const weekEndDate = new Date(weekStartDay.getTime());
      weekEndDate.setDate(weekEndDate.getDate() + 6);

      this.startDate = weekStartDay.getFullYear() + '-' + ('0' + (weekStartDay.getMonth() + 1)).slice(-2) + '-' + ('0' + weekStartDay.getDate()).slice(-2);
      this.endDate = weekEndDate.getFullYear() + '-' + ('0' + (weekEndDate.getMonth() + 1)).slice(-2) + '-' + ('0' + weekEndDate.getDate()).slice(-2);
    },
    async expandCard() {
      this.searchParametersCardExpanded = !this.searchParametersCardExpanded;
      if (!this.searchParametersCardExpanded) { return; }
      try {
        this.loadingSearchResults = true;
        this.transactionTypes = await (this as any).httpGet('/transaction-types', 'Failed to get Transaction Types') || [];
        this.transactionTypes.push({id: 0, name: 'Items with a Receipt'});
      } finally {
        this.loadingSearchResults = false;
      }
    },
    addFilter (filterList: any[], filter: any) {
      if(!filterList.some( ( (filterInstance: any) => filterInstance.id === filter.id ) ) ) {
        filterList.push(filter);
      }
    },
    removeFilter(filtersList: any[], filterId: Number) {
      for (let i=0; i<filtersList.length; i++) {
        if (filtersList[i].id === filterId) {
          filtersList.splice(i,1);
        }
      }
    },
    filterConjunctionUpdate (filterConjunctionBool: any, conjunctionBoo: boolean) {
      filterConjunctionBool = conjunctionBoo;
    },
    clearAll() {
      this.resetDates();
      this.type = -1;
      this.typeFilters.filters = [];
      this.typeFilters.isAnd = false;
    },
    async pullReport() {
      try {
        this.loadingSearchResults = true;
        const data = await (this as any).httpPost('/reports/billable-payables', 'Failed to load Report', this.getReportBody());
        if (data) {
          this.results = data.results;
          this.tableResults = data.tableResults;
          this.resultsExpanded = true;
        } else {
          this.results = {
            totalInvoices: 0,
            totalProviders: 0,
            totalFacilities: 0,
            totalBillable: 0,
            totalPayable: 0,
            totalMargin: 0,
            totalRows: 0,
            totalQuantity: 0
          };
          this.tableResults = [];
        }
      } finally {
        this.loadingSearchResults = false;
      }
    },
    getReportBody(): any {
      const expectingReceiptOnly = this.typeFilters.filters.some((filter: any) => filter.id === 0);
      const filters = this.typeFilters.filters.filter((filter: any) => filter.id !== 0);
      return {
        shiftStartDate: this.startDate,
        shiftEndDate: this.endDate,
        useReceiptDates: this.useReceiptDates,
        useInvoicePeriods: this.useInvoicePeriods,
        typeFilters: { filters: filters, isAnd: this.typeFilters.isAnd },
        expectingReceiptOnly: expectingReceiptOnly
      };
    },
    async download() {
      try {
        this.loadingSearchResults = true;
        const url = await (this as any).httpPost('/reports/billable-payables/csv', 'Failed to download data.', this.getReportBody());
        window.open(url, '_blank');
      } finally {
        this.loadingSearchResults = false;
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/reports/billablepayable/BillablePayablesReport.ts